import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyBfgffYfYcU3sKDLAckUVGVVJcT1DVk2yo",
  authDomain: "rhyto-superchat.firebaseapp.com",
  projectId: "rhyto-superchat",
  storageBucket: "rhyto-superchat.appspot.com",
  messagingSenderId: "307711944187",
  appId: "1:307711944187:web:265f62e9e8f41c0dc4975e"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
